import { render, staticRenderFns } from "./AddPremiseModal.vue?vue&type=template&id=57093ead&scoped=true"
import script from "./AddPremiseModal.vue?vue&type=script&lang=js"
export * from "./AddPremiseModal.vue?vue&type=script&lang=js"
import style0 from "./AddPremiseModal.vue?vue&type=style&index=0&id=57093ead&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57093ead",
  null
  
)

export default component.exports